import { Component, Input } from '@angular/core';
import { APP_CONFIG, Env } from '../../environment';
import { AnalyticsEventType } from '../../model/types/analytics.const';
import { SegmentProvider } from '../../providers/analytics/segment';
import { HttpProvider } from '../../providers/http/http';
import { LoggerEvent, LoggerProvider } from '../../providers/logger/logger';
import { ScriptProvider } from '../../providers/script/script';
import { RmtPopupComponent } from '../rmt-popup/rmt-popup';
import { Platform } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

declare let hcaptcha;

@Component({
  selector: 'xe-captcha',
  templateUrl: 'xe-captcha.html'
})
export class XeCaptchaComponent {
  @Input() render = false;
  static captchaPromise;
  static analyticsProvider;
  static challengeTimer;
  static challengeActive = false;
  static challengeText = '';
  static startGetToken = new Date().getTime();
  static pendingReject;
  static captchaSession = null;
  static captchaSessionDisabled = false;
  static tokenPrefix = 'T##';
  static widgetCounter = 1;
  static widgetID = null;
  static reinitCaptcha = false;
  static thresholdTimeout = 15000;
  siteKey;
  containerID;
  static translate: any;
  
  constructor(private scriptProvider : ScriptProvider,
              private httpProvider: HttpProvider,
              private platform: Platform,
              private analytics: SegmentProvider,
              private translate : TranslateService) {
    this.siteKey = APP_CONFIG.recaptchaKey;
    XeCaptchaComponent.analyticsProvider = analytics;
  //   this.platform.ready().then(() => {
  //     XeCaptchaComponent.init(this.scriptProvider);
  //   });
  //   XeCaptchaComponent.translate = this.translate;
  }

  getToken(location) {
    return XeCaptchaComponent.getTokenStatic(this.scriptProvider, this.httpProvider, location);
  }

  static init(scriptProvider) {
    if (!XeCaptchaComponent.captchaPromise)
      XeCaptchaComponent.captchaPromise = scriptProvider.loadScript('https://js.hcaptcha.com/1/api.js?host=127.0.0.1');
  }

  static getVisibleIFrames() {
    let count = 0;
    const iframes = document.getElementsByTagName('iframe');
    for (var i=0; i < iframes.length; i++) {
      const iframe = iframes[i];
      if (window.getComputedStyle(iframe).visibility !== 'hidden' && window.getComputedStyle(iframe).display !== 'none' && iframe.offsetWidth > 0)
        count++;
    }
    return count;
  }

  static checkVisibleChallange(location) {
    if (XeCaptchaComponent.challengeTimer)
      window.clearTimeout(XeCaptchaComponent.challengeTimer);

    const visibleIFrames = XeCaptchaComponent.getVisibleIFrames();
    XeCaptchaComponent.challengeTimer = window.setTimeout(() => {
      XeCaptchaComponent.challengeTimer = null;
      
      // hCaptcha has taken in testing up to 2500ms even without challenge hence we check additionally if an iframe has been opened to determine if we have a captcha challenge
      let visibleIFramesNew = XeCaptchaComponent.getVisibleIFrames();
      const durationMs = (new Date().getTime() - XeCaptchaComponent.startGetToken);
      if (visibleIFrames !== visibleIFramesNew) {
        XeCaptchaComponent.challengeActive = true;
        XeCaptchaComponent.challengeText = ' with challenge';
        
        if (durationMs >= 4000 && XeCaptchaComponent.challengeActive)
          LoggerProvider.error(this, LoggerEvent.SlowCatpcha, 'VERY SLOW start captcha challenge (' + durationMs + 'ms)');
        else if (durationMs >= 2000 && XeCaptchaComponent.challengeActive)
          LoggerProvider.warning(this, LoggerEvent.SlowCatpcha, 'SLOW start captcha challenge (' + durationMs + 'ms)');
        else
          LoggerProvider.info(this, 'Start captcha challenge (' + durationMs + 'ms)');
        XeCaptchaComponent.analyticsProvider.trackEvent({eventName: AnalyticsEventType.CaptchaChallengeStarted, analyticsData: { location, durationMs }});
      } else if (durationMs >= XeCaptchaComponent.thresholdTimeout) {
        XeCaptchaComponent.reinitCaptcha = true; // reinitialize the captcha since it eventually is broken
        LoggerProvider.error(this, LoggerEvent.CaptchaException, 'Captcha did not show up and gets cancelled (' + durationMs + 'ms) !');
        if (XeCaptchaComponent.pendingReject)
          XeCaptchaComponent.pendingReject(new Error('Captcha failed to initialize'));
        window.setTimeout(() => {
          RmtPopupComponent.showErrorWithLogTranslation("page.errorMessage.captchaError");
        }, 1000);
      } else {
        XeCaptchaComponent.checkVisibleChallange(location);
      }
    }, 500);
  }

  static getTokenStatic(scriptProvider, httpProvider, location) {
    return new Promise(async(resolve, reject) => {
      if (!APP_CONFIG.featureFlags.captcha) {
        resolve(null);
        return;
      } else if (HttpProvider.disableCaptcha) {
        LoggerProvider.info(this, 'Captcha is disabled');
        resolve(null);
        return;
      }

      try {
        if (XeCaptchaComponent.captchaSession)
        {
          if (httpProvider.isAuthTokenExpired(XeCaptchaComponent.captchaSession, 15)) {
            // if the captcha session has expired or will expire in 15 seconds we need to go create a new captcha session
            LoggerProvider.warning(this, LoggerEvent.CaptchaException, 'Captcha session expired');
            XeCaptchaComponent.captchaSession = null;
          } else {
            LoggerProvider.info(this, 'Using captcha session');
            resolve(XeCaptchaComponent.captchaSession);
            return;
          }
        }

        XeCaptchaComponent.init(scriptProvider);
        let initTries = 0;
        while (true) {
          const initialized = await XeCaptchaComponent.ensureInitWithFallback(scriptProvider);
          if (initialized)
            break;
          initTries++;
          if (initTries > 5) {
            LoggerProvider.error(this, LoggerEvent.CaptchaException, 'Captcha failed to load');
            reject(new Error('Captcha failed to load'));
            return;
          }
        }
        if (initTries > 0) {
          await new Promise((resolve) => {
            window.setTimeout(() => {
              resolve(true);
            }, 300);
          });
          LoggerProvider.warning(this, LoggerEvent.CaptchaException, 'Captcha took several init tries: ' + initTries);
        }

        let repeat = false;
        let tryCount = 0;
        do {
          repeat = false;
          tryCount++;
          let hcaptchaResolve;
          const hcaptchaPromise = new Promise(async(resolve) => {
            hcaptchaResolve = resolve;
          });

          if (XeCaptchaComponent.reinitCaptcha) {
            LoggerProvider.error(this, LoggerEvent.CaptchaException, 'Reinitialize captcha !');
            try {
              hcaptcha.remove(null);
            } catch (ex) {
              LoggerProvider.exception(this, ex, LoggerEvent.PageException, 'Failed to get remove captcha');
            }
            XeCaptchaComponent.updateSiteKey(APP_CONFIG.recaptchaKey);
            await new Promise((resolveTimer) => {
              window.setTimeout(() => {
                resolveTimer(true);
              }, 2500);
            });
          }

          LoggerProvider.info(this, 'Start captcha token');
  
          XeCaptchaComponent.challengeActive = false;
          XeCaptchaComponent.challengeText = '';
          XeCaptchaComponent.startGetToken = new Date().getTime();
          XeCaptchaComponent.checkVisibleChallange(location);
          XeCaptchaComponent.pendingReject = reject;  

          hcaptcha.execute(XeCaptchaComponent.widgetID, { async: true })
          .then(async ({ response, key }) => {
            XeCaptchaComponent.reinitCaptcha = false; // when we get here we don't need to reinitialize it since it worked in the end
            XeCaptchaComponent.pendingReject = null;
            window.clearTimeout(XeCaptchaComponent.challengeTimer);
            XeCaptchaComponent.challengeTimer = null;
            const durationMs = (new Date().getTime() - XeCaptchaComponent.startGetToken);
            if (durationMs >= 2000 && XeCaptchaComponent.challengeActive)
              LoggerProvider.error(this, LoggerEvent.SlowCatpcha, 'VERY SLOW received captcha token' + XeCaptchaComponent.challengeText + ' (' + durationMs + 'ms)', response);
            else if (durationMs >= 1000 && XeCaptchaComponent.challengeActive)
              LoggerProvider.warning(this, LoggerEvent.SlowCatpcha, 'SLOW received captcha token' + XeCaptchaComponent.challengeText + ' (' + durationMs + 'ms)', response);
            else
              LoggerProvider.info(this, 'Received captcha token' + XeCaptchaComponent.challengeText + ' (' + durationMs + 'ms)', response);

            hcaptchaResolve(true);

            try {
              if (XeCaptchaComponent.captchaSessionDisabled) {
                resolve(XeCaptchaComponent.tokenPrefix + response);
              } else {
                const result = await httpProvider.get(`${APP_CONFIG.API_URL}api/auth/captcha`, {}, null, { captchaToken: response });
                if (result && result.session) {
                  XeCaptchaComponent.captchaSession = result.session;
                  resolve(result.session);
                }
              }
              if (XeCaptchaComponent.challengeActive)
                XeCaptchaComponent.analyticsProvider.trackEvent({eventName: AnalyticsEventType.CaptchaChallengeFinished, analyticsData: { location, durationMs }});
            } catch (ex) {
              if (ex && (ex.status <= 0 || ex.status === 404) && APP_CONFIG.env !== Env.PROD) { // in testing the endpoint SecureResource hasn't been deployed everywhere - hence when we get the error of an unknown URL fallback to the obsolete endpoint
                LoggerProvider.warning(this, LoggerEvent.CaptchaException, 'Captcha not available');
                HttpProvider.disableCaptcha = true;
                resolve(null); 
                XeCaptchaComponent.analyticsProvider.trackEvent({eventName: AnalyticsEventType.CaptchaChallengeFailed, analyticsData: { location, durationMs, reason: 'Not available' }});
              } else if (ex.error && ex.error.RetVal === 7002) {
                LoggerProvider.warning(this, LoggerEvent.CaptchaException, 'Captcha session disabled');
                XeCaptchaComponent.captchaSessionDisabled = true;
                resolve(XeCaptchaComponent.tokenPrefix + response);
              } else
                throw ex;
            }
          })
          .catch(err => {            
            XeCaptchaComponent.reinitCaptcha = false; // when we get here we don't need to reinitialize it since it worked in the end
            XeCaptchaComponent.pendingReject = null;
            window.clearTimeout(XeCaptchaComponent.challengeTimer);
            XeCaptchaComponent.challengeTimer = null;
            const durationMs = (new Date().getTime() - XeCaptchaComponent.startGetToken);
            
            if (err === 'missing-captcha' && tryCount < 5) {
              XeCaptchaComponent.reinitCaptcha = true;
              repeat = true;
              LoggerProvider.info(this, 'Hcaptcha missing captcha error (' + durationMs + 'ms) => repeating', err);
            } else if (err === 'network-error' && tryCount < 5) {
              repeat = true;              
              LoggerProvider.info(this, 'Hcaptcha network error (' + durationMs + 'ms) => repeating', err);
            } else {
              LoggerProvider.exception(this, err, LoggerEvent.PageException, 'Failed to get captcha token' + XeCaptchaComponent.challengeText + ' (' + durationMs + 'ms)');
              reject(new Error('Captcha validation failed: ' + err));
            }

            if (XeCaptchaComponent.challengeActive)
              XeCaptchaComponent.analyticsProvider.trackEvent({eventName: AnalyticsEventType.CaptchaChallengeFailed, analyticsData: { location, durationMs, reason: err }});

            hcaptchaResolve(true);
          });

          await hcaptchaPromise;
          if (repeat)
            LoggerProvider.info(this, 'Repeat hcaptcha (try ' + tryCount + ')');
          else
            break;
        } while (repeat && tryCount < 10);
      }
      catch (ex) {
        XeCaptchaComponent.pendingReject = null;
        LoggerProvider.exception(this, ex, LoggerEvent.ComponentException, 'Failed to get captcha token');
        reject(ex);
      }
    })
  }

  static async updateSiteKey(key) {
    await XeCaptchaComponent.captchaPromise;
    const div = document.createElement('div');
    div.id = '__hcaptcha_' + XeCaptchaComponent.widgetCounter;
    XeCaptchaComponent.widgetCounter++;
    document.body.appendChild(div);
    XeCaptchaComponent.widgetID = hcaptcha.render(div.id, {
      'theme': 'dark',
      'size': 'invisible',
      'sitekey': key
    });
  }

  static async ensureInitWithFallback(scriptProvider, localFallback = false) {
    try {
      await XeCaptchaComponent.captchaPromise;
      if (typeof(hcaptcha) === 'undefined')
        throw new Error('HCaptcha undefined');
      return true;
    } catch (ex) {
      LoggerProvider.exception(this, ex, LoggerEvent.CaptchaException, 'Unable to init captcha - use fallback init');
      await new Promise((resolve) => {
        window.setTimeout(() => {
          resolve(true);
        }, 300);
      });
      let url = 'https://js.hcaptcha.com/1/api.js?host=127.0.0.1';
      if (localFallback)
        url = 'assets/hcaptcha/1/api.js?host=127.0.0.1';
      XeCaptchaComponent.captchaPromise = scriptProvider.loadScript(url);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/xe-captcha/xe-captcha.ts